var data = [
	{
		layers: [
		],
		modCategory: "DED",
		modType: "01",
		modulousId: "DED|01|UK-DED0001",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "entrance double door glazed",
		rvFamilyType: "1800x2040",
		totalThickness: 0,
		size: [
			1.82,
			2.085,
			0.2
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
			{
				name: "Window Frame"
			}
		],
		modCategory: "DTD",
		modType: "01",
		modulousId: "DTD|01|UK-DTD0001",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "technical space double door louvre",
		rvFamilyType: "1473x2110",
		size: [
			1.473,
			2.11,
			0.2
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DTS",
		modType: "01",
		modulousId: "DTS|01|UK-DTS0001",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "technical space single door louvre",
		rvFamilyType: "1010x2110",
		totalThickness: 0,
		size: [
			1.01,
			2.11,
			0.2
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "DIS",
		modType: "02",
		modulousId: "DIS|02|UK-DIS0004",
		rgTypes: [
			"Door"
		],
		rvFamilyName: "internal single door",
		rvFamilyType: "926x2040-corridor",
		totalThickness: 0,
		size: [
			1.01,
			2.09,
			0.2
		],
		color: "#564c83",
		sizeLock: [
			true,
			true,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "FCA",
		modType: "01",
		modulousId: "FCA|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "wall-cladd_36cld-66air-260ins",
		totalThickness: 0.362,
		size: [
			null,
			null,
			0.362
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "FCB",
		modType: "01",
		modulousId: "FCB|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "wall-cladd_36cld-66air-260ins",
		totalThickness: 0.362,
		size: [
			null,
			null,
			0.362
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "FCC",
		modType: "01",
		modulousId: "FCC|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "wall-cladd_36cld-66air-260ins",
		totalThickness: 0.362,
		size: [
			null,
			null,
			0.362
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "FCD",
		modType: "01",
		modulousId: "FCD|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "wall-cladd_36cld-66air-260ins",
		totalThickness: 0.362,
		size: [
			null,
			null,
			0.362
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	},
	{
		layers: [
		],
		modCategory: "FCE",
		modType: "01",
		modulousId: "FCE|01|",
		rgTypes: [
			"Wall"
		],
		rvFamilyName: "basic wall",
		rvFamilyType: "wall-cladd_36cld-66air-260ins",
		totalThickness: 0.362,
		size: [
			null,
			null,
			0.362
		],
		color: "#e6e0c8",
		sizeLock: [
			false,
			false,
			true
		]
	}
];

export { data as default };
//# sourceMappingURL=manual-rv-data.json.js.map
